import * as APPCONFIG from "../config/app-config.js";
import auth from "./AuthAPI.js";
import Http from "./Http.js";

export const kycSummary = (form) => {
  return auth({
    method: "get",
    url: `${APPCONFIG.API_URL}auth/kyc/kycSummary`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};
